import styles from "@/styles/Video.module.scss";
import OpenAppButton from "./OpenAppButton";
import AndroidAppDownloadBanner from "./AndroidAppDownloadBanner";
import IOSAppDownloadBanner from "./IOSAppDownloadBanner";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SuggestApp(_ref) {
  var watch = _ref.watch,
      state = _ref.state;
  var handleClick = useCallback(function () {
    state.standWatchOnBrowserFlag();
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.suggestApp,
    children: [/*#__PURE__*/_jsx(OpenAppButton, {
      watch: watch
    }), /*#__PURE__*/_jsxs("div", {
      className: styles["app-download-banner"],
      children: [/*#__PURE__*/_jsx(IOSAppDownloadBanner, {}), /*#__PURE__*/_jsx(AndroidAppDownloadBanner, {})]
    }), /*#__PURE__*/_jsx("div", {
      className: styles["watchOnBrowserLink"],
      children: /*#__PURE__*/_jsx("a", {
        className: "accentColor underline",
        onClick: handleClick,
        children: "\u30D6\u30E9\u30A6\u30B6\u3067\u8996\u8074\u3059\u308B"
      })
    })]
  });
}